import { Skeleton } from "@mui/material";
import stylesSection from "./RoadmapSection.module.css";
import stylesItem from "./RoadmapItem.module.css";

import StatusTitle from "components/StatusTitle";
import React from "react";
import { Status } from "tools/Enums";

export default function RoadmapSectionSkeleton({ status }) {
	const getStatusStyle = () => {
		if (status === Status.Planned) return "rgb(99, 219, 255, 0.1)";
		if (status === Status.InProgress) return "rgb(255, 227, 151, 0.3)";
		if (status === Status.Live) return "rgb(188, 226, 195, 0.3)";
	};
	const backgroundColor = getStatusStyle();
	return (
		<div>
			<div className={stylesSection.items}>
				<StatusTitle status={status} />
				<div className={stylesItem.container}>
					<Skeleton className={stylesItem.card} sx={{ backgroundColor: backgroundColor }} />
					<Skeleton className={stylesItem.card} sx={{ backgroundColor: backgroundColor }} />
					<Skeleton className={stylesItem.card} sx={{ backgroundColor: backgroundColor }} />
					<Skeleton className={stylesItem.card} sx={{ backgroundColor: backgroundColor }} />
					<Skeleton className={stylesItem.card} sx={{ backgroundColor: backgroundColor }} />
					<Skeleton className={stylesItem.card} sx={{ backgroundColor: backgroundColor }} />
				</div>
			</div>
		</div>
	);
}
